import { useMutation } from "@apollo/client";
import { MUTATE_PROFILE, USER_DELETE } from "../../GraphQL/mutateUser";

export const AccountViewmodel = () => {
  const [mutateProfile, { data, loading, error }] = useMutation(MUTATE_PROFILE);
  const [
    userDelete,
    { data: deleteData, loading: deleteLoading, error: deleteError },
  ] = useMutation(USER_DELETE);

  return {
    mutateProfile,
    data,
    loading,
    error,
    userDelete,
    deleteData,
    deleteLoading,
    deleteError,
  };
};
